import { DateHelper } from '../../../../../../../../helpers/date.helper';
import TravelTo from '../TravelTo';
import type { IConnectionLinkDetails } from '../../../../../../../../models/connection-link-details.model';

function ConnectionLink({ connectionLinkDetails }: { connectionLinkDetails: IConnectionLinkDetails }) {
  return (
    <div className="connection-link">
      <TravelTo
        transportMode={connectionLinkDetails.transportMode}
        durationInMinutes={DateHelper.getDurationFromDateStrings(
          connectionLinkDetails.origin.estimatedTime || connectionLinkDetails.origin.plannedTime,
          connectionLinkDetails.destination.estimatedTime || connectionLinkDetails.destination.plannedTime
        )}
        distanceInMeters={connectionLinkDetails.distanceInMeters}
      ></TravelTo>
    </div>
  );
}

export default ConnectionLink;
